import React from 'react';
import useEffectOnce from 'react-use/lib/useEffectOnce';
import { FullPageLoading } from '../../../../../CommonComponents/OPL/FullpageLoading/FullPageLoading';
import { useExternalAccountProvidersPollQuery } from '../api/useExternalAccountProvidersPollQuery';
import { useClientId } from '../../../../../_hooks/useClientId';
import { toast } from '../../../../../CommonComponents/OPL/Toast/Toast';
import { MESSAGES } from '../../../../../CommonConstants';

interface Props {
  contextId: string;
}

export const ExternalAccountProviderAuthLoading = ({ contextId }: Props) => {
  const { isError, data } = useExternalAccountProvidersPollQuery({ contextId });

  if (isError) {
    return <Error />;
  }

  if (data?.isCompleted) {
    return <Success />;
  }

  return <FullPageLoading />;
};

const Error = () => {
  useEffectOnce(() => {
    toast.error(MESSAGES.GENERIC_ERROR);
  });

  return null;
};

const Success = () => {
  const clientId = useClientId();

  useEffectOnce(() => {
    ADV.util.Router.go2('ProfileAccounts', {
      clientId,
      tabSlug: 'manageLinks',
    });
  });

  return null;
};
